{
  "#PRODUKTION_ROHSTOFFBILANZ": {
    "TITLE": "Rohstoffbilanz"
  }
}
